import React, { useContext, useEffect, useState } from "react";
import logo from "../../Logo.png";
import { IsHomePageContext } from "../Provider/IsHomePage";
function Navbar(props) {
  const [activeButton, setActiveButton] = useState("home");
  const { setHomePage } = useContext(IsHomePageContext);
  useEffect(() => {
    const aboutSection = props.aboutRef.current;
    const skillsSection = props.skillsRef.current;
    const experienceSection = props.experienceRef.current;
    const portfolioSection = props.portfolioRef.current;
    const referencesSection = props.referencesRef.current;
    const contactSection = props.contactRef.current;

    const handleScroll = () => {
      const scrollTop = window.pageYOffset;

      if (
        aboutSection.offsetTop - 110 <= scrollTop &&
        aboutSection.offsetTop + aboutSection.offsetHeight - 110 > scrollTop
      ) {
        setActiveButton("about");
        window.history.replaceState(null, null, "/about");
        setHomePage(false);
      } else if (
        skillsSection.offsetTop - 110 <= scrollTop &&
        skillsSection.offsetTop + skillsSection.offsetHeight - 110 > scrollTop
      ) {
        setActiveButton("skills");
        window.history.replaceState(null, null, "/skills");
        setHomePage(false);
      } else if (
        experienceSection.offsetTop - 110 <= scrollTop &&
        experienceSection.offsetTop + experienceSection.offsetHeight - 110 >
          scrollTop
      ) {
        setActiveButton("experience");
        window.history.replaceState(null, null, "/experience");
        setHomePage(false);
      } else if (
        portfolioSection.offsetTop - 110 <= scrollTop &&
        portfolioSection.offsetTop + portfolioSection.offsetHeight - 110 >
          scrollTop
      ) {
        setActiveButton("portfolio");
        window.history.replaceState(null, null, "/portfolio");
        setHomePage(false);
        // } else if (
        //   referencesSection.offsetTop - 110 <= scrollTop &&
        //   referencesSection.offsetTop + referencesSection.offsetHeight - 110 >
        //     scrollTop
        // ) {
        //   setActiveButton("references");
        //   window.history.replaceState(null, null, "/references");
        //   setHomePage(false);
      } else if (
        contactSection.offsetTop - 110 <= scrollTop &&
        contactSection.offsetTop + contactSection.offsetHeight - 110 > scrollTop
      ) {
        setActiveButton("contact");
        window.history.replaceState(null, null, "/contact");
        setHomePage(false);
      } else {
        setActiveButton("home");
        window.history.replaceState(null, null, "/portfolio");
        setHomePage(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [props.aboutRef, props.servicesRef, props.contactRef]);

  const handleScrollToHome = () => {
    window.scrollTo(0, 0);
  };

  const handleScrollToSkills = () => {
    const sectionTop =
      props.skillsRef.current.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({ top: sectionTop - 100, behavior: "smooth" });
  };

  const handleScrollToExperience = () => {
    const sectionTop =
      props.experienceRef.current.getBoundingClientRect().top +
      window.pageYOffset;
    window.scrollTo({ top: sectionTop - 100, behavior: "smooth" });
  };

  const handleScrollToAbout = () => {
    const sectionTop =
      props.aboutRef.current.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({ top: sectionTop - 100, behavior: "smooth" });
  };

  const handleScrollToPortfolio = () => {
    const sectionTop =
      props.portfolioRef.current.getBoundingClientRect().top +
      window.pageYOffset;
    window.scrollTo({ top: sectionTop - 100, behavior: "smooth" });
  };

  const handleScrollToReferences = () => {
    const sectionTop =
      props.referencesRef.current.getBoundingClientRect().top +
      window.pageYOffset;
    window.scrollTo({ top: sectionTop - 100, behavior: "smooth" });
  };

  const handleScrollToContact = () => {
    const sectionTop =
      props.contactRef.current.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({ top: sectionTop - 100, behavior: "smooth" });
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-fixed-top navbar-light bg-dark">
        <div className="container-fluid">
          <a className="navbar-brand" href="/portfolio">
            <img src={logo} alt="Logo.." className="logo"></img>
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <i className="fas fa-bars" style={{ color: "#fff" }}></i>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              <li className="nav-item active" onClick={handleScrollToHome}>
                <a
                  aria-current="page"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                  className={
                    activeButton === "home" ? "nav-link active" : "nav-link"
                  }
                >
                  Home
                </a>
                {/* <Link className="nav-link" aria-current="page" to="/portfolio">
                                    Home
                                </Link> */}
              </li>

              <li className="nav-item" onClick={handleScrollToSkills}>
                <a
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                  className={
                    activeButton === "skills" ? "nav-link active" : "nav-link"
                  }
                >
                  Skills
                </a>
              </li>
              <li className="nav-item" onClick={handleScrollToExperience}>
                <a
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                  className={
                    activeButton === "experience"
                      ? "nav-link active"
                      : "nav-link"
                  }
                >
                  Experience
                </a>
              </li>
              <li className="nav-item" onClick={handleScrollToPortfolio}>
                <a
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                  className={
                    activeButton === "portfolio"
                      ? "nav-link active"
                      : "nav-link"
                  }
                >
                  Portfolio
                </a>
              </li>
              <li className="nav-item" onClick={handleScrollToAbout}>
                <a
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                  className={
                    activeButton === "about" ? "nav-link active" : "nav-link"
                  }
                >
                  About
                </a>
              </li>
              {/* <li className="nav-item" onClick={handleScrollToReferences}>
                <a
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                  className={
                    activeButton === "references"
                      ? "nav-link active"
                      : "nav-link"
                  }
                >
                  References
                </a>
              </li> */}
              <li className="nav-item" onClick={handleScrollToContact}>
                <a
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                  className={
                    activeButton === "contact" ? "nav-link active" : "nav-link"
                  }
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
